import React, { Component } from "react";
import "./styles.css";
import Icon from "../../prefabs/icon/view";

class FloatingArrows extends Component {

  // ===============================================================================================
  constructor(props) {
    super(props);

    this.scrollToTop  = this.scrollToTop.bind(this);
    this.onClickLeft  = this.onClickLeft.bind(this);
    this.onClickRight = this.onClickRight.bind(this);

    // this.navs = this.props.items.slice();
    // this.navs.shift();  // Remove "intro"

    this.firstSlide = 0;
    this.lastSlide  = 10;
  }



  // ===============================================================================================
  scrollToTop(cb) {
    document.querySelector('.swiper-container-scroll-anchor').scrollIntoView({
      behavior: 'smooth',
      block:    'start',
    });
    cb();
  }




  // ===============================================================================================
  onClickLeft(e) {
    e.preventDefault();
    if (this.props.activeSlide !== this.firstSlide) {
      this.scrollToTop(() => {
        this.props.handleChange(this.props.activeSlide - 1);
      });
    }
  }



  // ===============================================================================================
  onClickRight(e) {
    e.preventDefault();
    if (this.props.activeSlide !== this.lastSlide) {
      this.scrollToTop(() => {
        this.props.handleChange(this.props.activeSlide + 1);
      });
    }
  }

  // ===============================================================================================
  render() {
    return (
      <nav className="floating-arrows">
        <div className="floating-arrows__wrapper">



          <div className={"floating-arrows__left" +
            ((this.props.activeSlide === this.firstSlide) ? " floating-arrows__left--first" : "")}>
            <button
              className={"floating-arrows__nav-btn floating-arrows__nav-btn--left" +
                ((this.props.activeSlide === this.firstSlide) ? " floating-arrows__nav-btn--inactive" : "")}
              tabIndex="-1"
              onClick={this.onClickLeft}>
              <Icon className="nav-arrow nav-arrow--left nav-arrow--sm" type="nav-left"   />
              <Icon className="nav-arrow nav-arrow--left nav-arrow--lg" type="nav-left-y" />
              <span className="nav-label nav-label--left"> Previous </span>
            </button>
          </div>



          <div className="floating-arrows__middle">
          </div>



          <div className="floating-arrows__right">
            <button className="floating-arrows__nav-btn"
              tabIndex="-1"
              onClick={this.onClickRight}>
              <span className="nav-label nav-label--right"> Next </span>
              <Icon className="nav-arrow nav-arrow--right nav-arrow--sm" type="nav-left"   />
              <Icon className="nav-arrow nav-arrow--right nav-arrow--lg" type="nav-left-y" />
            </button>
          </div>



        </div>
      </nav>
    );
  }

}



export default FloatingArrows
